import axios from "axios"
import { IListingRequestModel, IListingResponseModel } from "./_models"
import { CONST_API_PERSONNEL_POST_GET_ANNUAIRE_ENDPOINT } from "../../../../endpoints"

export function getAnnuairePersonnelRequest(payload: IListingRequestModel) {
     return axios.post<IListingResponseModel>(CONST_API_PERSONNEL_POST_GET_ANNUAIRE_ENDPOINT, payload)
}
